/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import AdvisorsCarousel from "./OurAdvisors.container";

export default AdvisorsCarousel;
